import { useCallback } from 'react';
import { PoolSubject } from 'libs/end-to-end/src/copilot';
import { SetterWithReducer } from 'libs/end-to-end/src/ui-types';

export type BasicCopilotAddToSlateFn = (subject: PoolSubject) => void;

export const useBasicCopilotAddToSlate = ({
  setSelectedSlateIds,
}: {
  setSelectedSlateIds: SetterWithReducer<string[]>;
}): BasicCopilotAddToSlateFn => {
  return useCallback(
    (subject: PoolSubject) => {
      const id = subject.id;

      setSelectedSlateIds((current) => {
        return [...(current ?? []), id];
      });
    },
    [setSelectedSlateIds],
  );
};
